import React, { useCallback } from 'react';

import { makeStyles } from 'tss-react/mui';

import EDIconButton from '../BaseComponents/Buttons/IconButton/EDIconButton';
import { downloadDocument, getDocumentUrl } from './Documents/Documents';

interface IProps {
  blobId: string;
  extension: string;
  fileName: string;
  disabled?: boolean;
  hidden?: boolean;
}

const useStyles = makeStyles()(theme => ({
  iconButton: {
    cursor: 'pointer',
    pointerEvents: 'all',
  },
}));

const FakturaDokumentDownloadIkon: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();

  const onClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      event.preventDefault();

      downloadDocument(
        props.fileName,
        getDocumentUrl(props.blobId),
        props.extension
      );
    },
    [props.blobId, props.extension, props.fileName]
  );

  return !props.hidden ? (
    <EDIconButton
      onClick={onClick}
      icon="download"
      tooltip="Ladda ner dokument"
      margin="dense"
      padding="dense"
      disabled={props.disabled}
      className={classes.iconButton}
    />
  ) : (
    <></>
  );
};

export default FakturaDokumentDownloadIkon;
